
import XHeader from 'vux/src/components/x-header/index.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import Divider from 'vux/src/components/divider/index.vue'


const swiperList = [{
url: 'javascript:',
img: 'https://ww1.sinaimg.cn/large/663d3650gy1fq66vvsr72j20p00gogo2.jpg',
title: '送你一朵fua'
}, {
url: 'javascript:',
img: 'https://ww1.sinaimg.cn/large/663d3650gy1fq66vw1k2wj20p00goq7n.jpg',
title: '送你一辆车'
}, {
url: 'javascript:',
img: 'https://static.vux.li/demo/5.jpg', // 404
title: '送你一次旅行',
fallbackImg: 'https://ww1.sinaimg.cn/large/663d3650gy1fq66vw50iwj20ff0aaaci.jpg'
}]


export default {
components: {
XHeader,
Swiper,
Divider
},
data () {
return {
swiperList:swiperList,
swiperIndex: 0,
}
},
methods: {
swiperChange (index) {
this.swiperIndex = index
}
}
}



// WEBPACK FOOTER //
// ./src/views/score/detail.vue